import React, { Component } from 'react';
import FooterWrapper from './ui/footer/FooterWrapper';
import Version from './ui/footer/Version';

class Footer extends Component {
    render() {
        return (
            <FooterWrapper>
                Copyright © {this.props.text}. All rights reserved.
                <br />
                <Version>{process.env.REACT_APP_VERSION}</Version>
            </FooterWrapper>
        );
    }
}

export default Footer;